export const GTM_ID = 'GTM-KKMM7BD';

export const pageview = (url: string) => {
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
	window?.dataLayer?.push({
		event: 'pageview',
		page: url,
	});
};
